import { ApiProperty } from '@nestjs/swagger';
import { VdPdfParticipacionDto } from './liquidacion-vd-pdf.dto';

export class VdPdfTemporadaStatsDto {
  @ApiProperty({ example: '2024 - 2025' })
  temporada!: string;

  @ApiProperty({ example: '2025-02-28' })
  fechaCorte!: string; // ISO yyyy-mm-dd

  @ApiProperty({ example: 158 })
  contenedores!: number; // acumulado temporada hasta fechaCorte

  @ApiProperty({ example: 339222 })
  vdUsd!: number; // acumulado temporada hasta fechaCorte

  @ApiProperty({ example: 0 })
  descuentosUsd!: number; // acumulado temporada hasta fechaCorte
}

export class VdPdfTotalsKpiDto {
  @ApiProperty({ example: 158 })
  totalContenedores!: number; // del periodo de la liquidación

  @ApiProperty({ example: 339222 })
  totalVdUsd!: number; // del periodo de la liquidación

  @ApiProperty({ example: 3 })
  totalDestinos!: number; // del periodo de la liquidación

  @ApiProperty({ example: -8, required: false })
  cntrDeltaPct?: number | null;

  @ApiProperty({ example: -38, required: false })
  vdDeltaPct?: number | null;

  @ApiProperty({ example: -40, required: false })
  destinosDeltaPct?: number | null;
}

export class VdPdfDestinoItemDto {
  @ApiProperty({ example: 'ROTTERDAM' })
  destino!: string;

  @ApiProperty({ example: 96 })
  porcentaje!: number;

  @ApiProperty({ example: 151 })
  contenedores!: number;
}

export class VdPdfParticipacionDestinosDto {
  @ApiProperty({ example: 158 })
  totalContenedores!: number;

  @ApiProperty({ type: [VdPdfDestinoItemDto] })
  items!: VdPdfDestinoItemDto[];
}

export class LiquidacionVdPdfPage4Dto {
  @ApiProperty({ type: VdPdfTemporadaStatsDto })
  temporadaStats!: VdPdfTemporadaStatsDto;

  @ApiProperty({ type: VdPdfTotalsKpiDto })
  kpis!: VdPdfTotalsKpiDto;

  @ApiProperty({ type: VdPdfParticipacionDto })
  participacionNaviera!: VdPdfParticipacionDto;

  @ApiProperty({ type: VdPdfParticipacionDestinosDto })
  participacionDestinos!: VdPdfParticipacionDestinosDto;
}
